import {Directive, effect, ElementRef, inject, input, InputSignal, Renderer2} from "@angular/core";
import {CachedImageService} from "./cached-image.service";
import {FedeltaImageData} from "@fedelta-pos/data-client";

@Directive({
    selector: "[woa-image-cache]"
})
/**
 * Directive to load an image using the ImageService
 */
export class ImageCacheDirective {
    private element: ElementRef = inject(ElementRef);
    private renderer: Renderer2 = inject(Renderer2);
    private imageService: CachedImageService = inject(CachedImageService);

    public readonly imageData: InputSignal<FedeltaImageData | undefined> = input<FedeltaImageData | undefined>(undefined, {alias: "woa-image-cache"});

    constructor() {
        effect(() => {
            const value: FedeltaImageData | undefined = this.imageData();

            this.renderer.removeClass(this.element.nativeElement, "cached-image-loaded");
            this.renderer.removeClass(this.element.nativeElement, "cached-image-loading");
            this.renderer.removeClass(this.element.nativeElement, "cached-image-none");

            if (value && value.image) {
                this.element.nativeElement.src = "data:image/png;base64," + value.image;
                this.renderer.addClass(this.element.nativeElement, "cached-image-loaded");
                this.renderer.removeClass(this.element.nativeElement, "cached-image-loading");
            } else if (value && value.id) {
                this.renderer.addClass(this.element.nativeElement, "cached-image-loading");
                (async () => {
                    try {
                        this.element.nativeElement.src = "data:image/png;base64," + await this.imageService.getImage(value.id, value.hash);
                        this.renderer.addClass(this.element.nativeElement, "cached-image-loaded");
                        this.renderer.removeClass(this.element.nativeElement, "cached-image-loading");
                    } catch (error) {
                        this.element.nativeElement.src = "";
                        this.element.nativeElement.alt = "";
                    }
                })();
            } else {
                this.element.nativeElement.src = "";
                this.element.nativeElement.alt = "";
                this.renderer.addClass(this.element.nativeElement, "cached-image-none");
            }
        });
    }
}
